var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import '@gouvfr/dsfr/dist/component/checkbox/checkbox.min.css';
/**
 * @deprecated utiliser `CheckboxControl` ou `CheckboxGroup`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var Checkbox = React.forwardRef(function (_a, ref) {
    var label = _a.label, name = _a.name, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, texteAide = _a.texteAide, _c = _a.taille, taille = _c === void 0 ? "md" : _c, _d = _a.required, required = _d === void 0 ? false : _d, error = _a.error, warning = _a.warning, valid = _a.valid, className = _a.className, otherProps = __rest(_a, ["label", "name", "value", "disabled", "texteAide", "taille", "required", "error", "warning", "valid", "className"]);
    var idInput = "".concat(name, "-").concat(value);
    var checkboxClassName = "".concat(className, " fr-checkbox-group dsmi-checkbox-group");
    if (taille && taille !== "md") {
        checkboxClassName += " fr-checkbox-group--".concat(taille);
    }
    var texteValidation = undefined;
    if (disabled) {
        checkboxClassName += " fr-checkbox-group--disabled";
    }
    else if (error) {
        checkboxClassName += " fr-checkbox-group--error";
        if (typeof error === 'object' && "message" in error && error.message) {
            texteValidation = {
                id: "".concat(name, "-desc-error"),
                message: error.message,
                className: "fr-error-text",
            };
        }
    }
    else if (warning) {
        checkboxClassName += " fr-checkbox-group--warning";
        if (typeof warning === 'object' && "message" in warning && warning.message) {
            texteValidation = {
                id: "".concat(name, "-desc-warning"),
                message: warning.message,
                className: "fr-warning-text",
            };
        }
    }
    else if (valid) {
        checkboxClassName += " fr-checkbox-group--valid";
        if (typeof valid === 'object' && "message" in valid && valid.message) {
            texteValidation = {
                id: "".concat(name, "-desc-valid"),
                message: valid.message,
                className: "fr-valid-text",
            };
        }
    }
    return (React.createElement("div", { className: checkboxClassName },
        React.createElement("input", __assign({ 
            // @ts-ignore
            ref: ref, type: "checkbox", id: idInput, name: name, value: value, disabled: disabled, required: required }, otherProps)),
        React.createElement("label", { className: "fr-label", htmlFor: idInput },
            label,
            texteAide && React.createElement("span", { className: "fr-hint-text" }, texteAide)),
        texteValidation && (React.createElement("p", { id: texteValidation.id, className: texteValidation.className }, texteValidation.message))));
});
export default Checkbox;
